import React, { useState, useEffect } from "react";
import "./Navbar.css";
import { Button } from "./Button";
import "./Button.css";
import { Link } from "react-router-dom";
import "./Navbar.css";

const Nav = () => {
  const [click, setClick] = useState(false);
  const [button, setButton] = useState(true);

  const handleClick = () => setClick(!click);
  const closeMobileMenu = () => setClick(false);

  const showButton = () => {
    if (window.innerWidth <= 960) {
      setButton(false);
    } else {
      setButton(true);
    }
  };

  useEffect(() => {
    showButton();
  }, []);

  window.addEventListener("resize", showButton);

  return (
    <>
      {/* <nav className="navbar">
        <h4 className="stayOnTop">
          🚀 Interview will be held at oct 20 , 2022 🚀
        </h4>
        <div className="navbar-container">
          <Link
            to="/"
            className="navbar-logo"
            style={{ marginLeft: -11 }}
            onClick={closeMobileMenu}
          >
            KiNFiSH
            <i class="fab fa-typo3" />
          </Link>
        </div>
      </nav> */}
      <nav className="navbar">
        <div className="navbar-container">
          <Link
            to="/"
            className="navbar-logo"
            style={{ marginLeft: -11 }}
            onClick={closeMobileMenu}
          >
            KiNFiSH
          </Link>
          <div className="menu-icon" onClick={handleClick}>
            <i className={click ? "fas fa-times" : "fas fa-bars"} />
          </div>
          <ul className={click ? "nav-menu active" : "nav-menu"}>
            <li className="nav-item">
              <Link to="/" className="nav-links" onClick={closeMobileMenu}>
                Home
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/register"
                className="nav-links"
                onClick={closeMobileMenu}
              >
                Register
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/profile"
                className="nav-links"
                onClick={closeMobileMenu}
              >
                Profile
              </Link>
            </li>
            <li className="nav-item">
              <Link
                to="/progress"
                className="nav-links"
                onClick={closeMobileMenu}
              >
                Progress
              </Link>
            </li>

            <li>
              <Link
                to="/about"
                className="nav-links-mobile"
                onClick={closeMobileMenu}
              >
                About A2SV
              </Link>
            </li>
          </ul>
          {button && (
            <Link to="/about" className="nav-link-mobile">
              <button
                buttonStyle="btn--outline"
                className="btn btn--primary btn--outline btn--medium"
                buttonStyle="btn--outline"
                buttonSize="btn--medium"
              >
                {" "}
                About A2SV
              </button>{" "}
            </Link>
          )}
        </div>
      </nav>
    </>
  );
};

export default Nav;
